<app-tooltip-template label="select.conversion_metric" *ngIf="params.conversion_metric">
  <app-source [item]="params.conversion_metric" [width]="15"></app-source>
</app-tooltip-template>
